<template>
    <el-dropdown ref="dropdown" class="service" trigger="click" @visible-change="visibleChange" :hide-on-click="false">
        <div class="dropdown-title">
            <i class="auth-icon-swich-system dropdown-img"></i>
            <span>{{this.text}}</span>
        </div>
        <el-dropdown-menu slot="dropdown" class="app-list-switch">
            <el-input
                v-model="serachText"
                @input="handleEnter"
                size="medium"
                :placeholder="$translate('component.E1202104124672', { defaultText: '请输入搜索内容' })"
                class="serach-input">
            </el-input>
            <a target="_blank"
                v-for="item in copyAppList"
                @click="goCopyAppListPath(item)"
                :key="item.applicationCode">
                <el-dropdown-item name="system">{{item.applicationName}}</el-dropdown-item>
            </a>
        </el-dropdown-menu>
    </el-dropdown>
</template>
<script>
import { mapGetters } from 'vuex';
import config from '@/config/user.env';
import { I18nMixins } from '@/components/utils/i18n';
import bigDataLog from '@/utils/bigDataLog';

export default {
    mixins: [I18nMixins],
    created() {
        this.copyAppList = JSON.parse(JSON.stringify(this.appList));
    },
    mounted() {
        this.$refs.dropdown.triggerElm.removeEventListener('keydown', this.$refs.dropdown.handleTriggerKeyDown);
        // this.$refs.dropdown
    },
    data() {
        return {
            copyAppList: [],
            serachText: ''
        };
    },
    computed: {
        text() {
            const currentPath = this.appList.find(item => {
                if (item.applicationDomain && item.customDomain) {
                    return item.customDomain === window.location.hostname &&
                    item.applicationDomain.indexOf(window.location.pathname) >= 0;
                }
                return false;
            });
            if (currentPath && currentPath.applicationName) {
                return currentPath.applicationName;
            } else {
                return '';
            }
        },
        ...mapGetters(['appList'])
    },
    methods: {
        visibleChange(flag) {
            if (!flag) {
                this.serachText = '';
                this.handleEnter();
            } else {
                this.$refs.dropdown.triggerElm.removeEventListener('keydown', this.$refs.dropdown.handleTriggerKeyDown);
                this.copyAppList = JSON.parse(JSON.stringify(this.appList));
            }
        },
        handleEnter(e) {
            if (this.serachText) {
                this.copyAppList = this.appList.filter(item => {
                    return item.applicationName.toUpperCase().indexOf(this.serachText.toUpperCase()) !== -1;
                });
            } else {
                this.copyAppList = this.appList;
            }
        },
        goCopyAppListPath(item) {
            const env = config.env !== undefined ? config.env.toLowerCase() : 'sit';
            const isProd = env !== 'prod';
            const anGopath = isProd ? 'an-' + env + '.midea.com' : 'an.midea.com';
            const authGopath = isProd ? 'auth-' + env + '.midea.com' : 'auth.midea.com';
            const lcGopath = isProd ? 'l' + env + '.midea.com' : 'lc.midea.com';
            let pathUrl = '';
            const application = item.applicationDomain;
            const dealPathUrl = this.dealPathUrl(application, lcGopath);
            if (item.customDomain) {
                if (item.customDomain && item.customDomain.indexOf('//') > -1) {
                    pathUrl = item.customDomain + application;
                } else {
                    pathUrl = '//' + item.customDomain + application;
                }
            } else if (document.domain === anGopath || document.domain === authGopath) {
                pathUrl = this.dealPathUrl(application, document.domain);
            } else {
                pathUrl = dealPathUrl;
            }
            this.openNewPath(pathUrl);
            bigDataLog.sendDetailMessageByKey('bigData-btn-header-bar-system');
        },
        openNewPath(pathUrl) {
            var el = document.createElement('a');
            document.body.appendChild(el);
            el.target = '_blank'; // 指定在新窗口打开
            el.href = pathUrl;
            el.click();
            document.body.removeChild(el);
        },
        dealPathUrl(application, getPathDomain) {
            if (application.indexOf('//') > -1) {
                return application;
            } else if (application.charAt(0) !== '/') {
                return '//' + getPathDomain + '/' + application;
            } else {
                return '//' + getPathDomain + application;
            }
        }
    }
};
</script>
<style lang="less">
    .service{
        cursor: pointer;
        margin-right: 20px;
        .dropdown-title{
            &:focus{
                outline: 0;
            }
            .dropdown-img{
                font-size: 20px;
                margin-right: 8px;
                vertical-align: middle;
            }
        }
    }
    .app-list-switch{
        .serach-input {
            .el-input__inner {
                border: 0;
                border-bottom: 1px solid #DCDFE6;
            }
        }
    }
</style>
